import { signal } from '@preact/signals-react'

export const isOpenGroupingExportsModal = signal(null)

// which FTP_EXPORT_GROUP_EXECUTIONS rows the page lists: 'execution' (grouped exports) or
// 'one_way_generation' (the grouped One Way workbooks built by the generation service)
export const groupingExecutionType = signal('execution')
